module.exports = __webpack_public_path__ + "186b546333ca9820f51373c34ce429de.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/icon-calendar.svg
// module id = 4
// module chunks = 0